export class QuotingConstants {
    public static readonly WIZARD_CALCULATION_TYPE_CALCOLATO: string = "calcolato";
    public static readonly WIZARD_CALCULATION_TYPE_CALCOLATO_SCONTISTICA: string = "calcolato_scontistica";
    public static readonly WIZARD_CALCULATION_TYPE_LISTINO: string = "listino";
    public static readonly WIZARD_CALCULATION_TYPE_LISTINO_SCONTISTICA: string = "listino_scontistica";
    public static readonly WIZARD_CALCULATION_TYPE_CALCOLATO_RICHIESTA_PREVENTIVO: string = "calcolato_richiesta_preventivo";
    public static readonly WIZARD_CALCULATION_TYPE_CALCOLATO_LISTINO: string = "calcolato_listino_standard";
    public static readonly WIZARD_CALCULATION_TYPE_CALCOLATO_LISTINO_SCONTISTICA: string = "calcolato_listino_scontistica";
    public static readonly WIZARD_CALCULATION_TYPE_CALCOLATO_LISTINO_FORNITORI: string = "calcolato_listino_fornitori";
    public static readonly WIZARD_CALCULATION_TYPE_CALCOLATO_LISTINO_FORNITORI_SCONTISTICA: string = "calcolato_listino_fornitori_scontistica";
    ;
    
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/models/constants/quoting-constants.ts